import React, { useEffect, useState } from "react";
import Moment from "react-moment";
import useAccount from "classes/Accounts/hooks/useAccount";
import DocumentsController from "classes/Documents/DocumentsController";
import "./DocsSelector.css";
import SearchBar from "components/SearchBar/SearchBar";
import ScrollTable from "components/ScrollTable/ScrollTable";
import { t } from "i18next";
import DocUploader from "Pages/Documents/components/DocUploader/DocUploader";
import Button from "components/Button/Button";
import SwitchInput from "components/Inputs/Switch/SwitchInput";
import BackButton from "components/Button/BackButton";
import { TypeRights, returnRightsFromName } from "includes/rightType";
import useTemplate from "hooks/useTemplate";

function DocsSelector(props) {
	const { account } = useAccount();
	const { template } = useTemplate();

	const [isValidateBtnVisible, setIsValidateBtnVisible] = useState(false);

	const [docsFromUploader, setDocsFromUploader] = useState([]);

	const [selectedExistingDocs, setSelectedExistingDocs] = useState([]);

	const handleUploaderConfirmation = (preparedDocsArray) => {
		setDocsFromUploader(preparedDocsArray);
	};

	const handleFinalSubmission = () => {
		const finalDocsList = [...docsFromUploader, ...selectedExistingDocs];

		if (props.handleUpload) {
			props.handleUpload(finalDocsList);
		}

		props.handleClose();
	};

	useEffect(() => {

		setIsValidateBtnVisible(docsFromUploader.length > 0 || selectedExistingDocs.length > 0);

	}, [docsFromUploader, selectedExistingDocs])


	return (
		<>
			<BackButton onClick={props.handleClose} />
			<div className="d-flex container-uploadFiles" style={{ gap: "20px" }}>
				<DocUploader
					typeId={4}
					primaryColor={template?.primaryColor()}
					companyId={account.CompanyId}
					onConfirm={handleUploaderConfirmation}
					docsUtilImport={true}
					className="light-bg"
					noPreviews={true}
				/>
				<ExistingDocs
					{...props}
					selected={selectedExistingDocs}
					setSelected={setSelectedExistingDocs}
				/>
			</div>

			{isValidateBtnVisible && (
				<div className="mt-3">
					<Button
						className="btn-green w-auto m-auto p-3"
						onClick={handleFinalSubmission}
					>
						{t("Commons.VALIDATE")} ({docsFromUploader.length + selectedExistingDocs.length})
					</Button>
				</div>
			)}
		</>
	);
}

function ExistingDocs(props) {
	const [search, setSearch] = useState("");
	const { account } = useAccount();

	return (
		<div className="ExistingsDocs">
			<h2>{t("Files.SELECT_MULTIPLES_FILES")}</h2>
			<SearchBar className="w-100 mb-2" onChange={setSearch} />
			<DocumentsController
				typeId={4}
				companyId={account.CompanyId}
				childComponent={DocsList}
				childProps={{
					search: search,
					selected: props.selected,
					setSelected: props.setSelected,
					onItemClick: props.onItemClick,
					noImport: true
				}}
			/>
		</div>
	);
}

export function DocsList(props) {
	const {
		docs,
		search,
		selected,
		setSelected,
		onItemClick
	} = props;

	const [modifiedDocs, setModifiedDocs] = useState({});

	const handleItemPropertyChange = (item, property, value) => {
		setModifiedDocs(prev => ({
			...prev,
			[item.DocumentId]: {
				...prev[item.DocumentId],
				[property]: value
			}
		}));
	};


	const cols = [
		{ name: "Name", title: t("Table.NAME") },
		{ name: "Aperçu", title: t("Table.PREVIEW"), sort: false, component: PreviewCell },
		{
			name: "Docs utiles", title: "Docs utiles", sort: false, component: (cellProps) => (
				<DocsUtilesSwitch
					{...cellProps}
					onItemPropertyChange={handleItemPropertyChange}
					modifiedValue={modifiedDocs[cellProps.item.DocumentId]?.AddToDocsUtiles}
				/>
			), hidden: props.noImport
		},
		{ name: "LastChanged", title: t("Table.DATE"), component: DateCell },
	];

	return (
		<>
			{docs.length > 0 && (
				<div className="DocsList">
					<ScrollTable
						items={docs.map((a) => {
							if (a.TempId) return { ...a, DocumentId: a.TempId };
							return a;
						})}
						cols={cols}
						itemId={"DocumentId"}
						sortBy="Name"
						className="dark-bg"
						search={search}
						selected={selected}
						setSelected={setSelected}
						checkbox={true}
						onItemClick={onItemClick}
					/>
				</div>
			)}
		</>
	);
}

function PreviewCell(props) {
	let doc = props.item;
	if (!doc?.Url_Origin) return <div>{t("Commons.ERROR")}</div>;
	if (doc.TempId) return <div>{t("Docs.IMPORTED_DOCS")}</div>;
	return (
		<a href={doc.Url_Origin} rel="noreferrer" onClick={(e) => e.stopPropagation()} target="_blank">
			{t("Table.PREVIEW")}
		</a>
	);
}

function DocsUtilesSwitch(props) {
	const { item, onItemPropertyChange, modifiedValue } = props;

	const { account } = useAccount();
	const checkRight = () => {
		const rigthName = TypeRights.AdminDocument;
		try {
			return returnRightsFromName(account.Rights, rigthName);
		} catch (error) {
			return true;
		}
	};

	const currentValue = modifiedValue !== undefined ? modifiedValue : item.AddToDocsUtiles;

	if (!item.TempId) return "Non modifiable";
	return (
		<>
			{checkRight() && (
				<SwitchInput
					disabled={!item.TempId}
					checked={!item.TempId || currentValue}
					onClick={(e) => e.stopPropagation()}
					className="w-100"
					onChange={(val) => {
						onItemPropertyChange?.(item, 'AddToDocsUtiles', val);
					}}
					onlyState={true}
					label={item.TempId ? "Importer" : "Déjà présent"}
				/>
			)}
		</>
	);
}

function DateCell(props) {
	return (
		<Moment format={t("Events.TILE_DATE_FORMAT")}>
			{props.item.LastChanged}
		</Moment>
	);
}

export default DocsSelector;